export default __webpack_public_path__ + "static/media/HoursSaved.7dab97b7.svg";